import { Avatar } from "@/components/catalyst/avatar";
import { type MediaFieldsFragment } from "@/gql/graphql";
import { getInitials } from "@/lib/Utils/getInitials";
import { cn } from "@/lib/utils";

const INITIALS_CLASSES =
  "bg-linear-to-b from-[#6f6896] to-[#3d3857] text-white [&_svg]:font-semibold shadow-[inset_0_1px_0_rgb(255_255_255/0.3),inset_0_-2px_3px_rgb(0_0_0/0.25),0_1px_3px_rgb(0_0_0/0.3)]";

export function ThreadUserAvatar({
  name,
  media,
  className,
}: {
  name: string | null;
  media: MediaFieldsFragment | null | undefined;
  className?: string;
}) {
  return (
    <Avatar
      className={cn(
        "shrink-0 outline -outline-offset-1 outline-black/5",
        media ? "bg-gray-200" : INITIALS_CLASSES,
        className,
      )}
      media={media ?? null}
      initials={name ? getInitials(name) : ""}
    />
  );
}
